import React, { useEffect, useState } from 'react';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import { CheckIcon, WarningIcon } from '@chakra-ui/icons';

export const SaveStatus = ({ status, onClear }) => {
  const [visible, setVisible] = useState(!!status);
  
  useEffect(() => {
    if (status) {
      setVisible(true);
      
      // Clear status after a delay, unless it's a loading state
      if (!status.includes('...')) {
        const timer = setTimeout(() => {
          setVisible(false);
          if (onClear) setTimeout(onClear, 300);
        }, 2000);
        
        return () => clearTimeout(timer);
      }
    } else {
      setVisible(false);
    }
  }, [status, onClear]);
  
  if (!status || !visible) return null;
  
  const isError = status.toLowerCase().includes('fail') || status.toLowerCase().includes('error');
  const isSuccess = status === 'Saved!' || status.includes('successfully');
  const isLoading = status.includes('...');
  
  return (
    <Box 
      position="fixed"
      top="20px"
      right="20px"
      bg={isError ? 'red.500' : isSuccess ? 'green.500' : 'blue.500'}
      color="white"
      px={4}
      py={2}
      borderRadius="md"
      boxShadow="md"
      zIndex={9999}
      opacity={visible ? 1 : 0}
      transition="opacity 0.3s ease"
    >
      <Flex align="center">
        {isLoading && <Spinner size="sm" mr={2} />}
        {isSuccess && <CheckIcon mr={2} />}
        {isError && <WarningIcon mr={2} />}
        <Text fontWeight="medium">{status}</Text>
      </Flex>
    </Box>
  );
};

export default SaveStatus;